import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/Logo_round.png";
import { BRAND_NAME } from "../constants";
import { BRAND_COLOR } from "../constants";

const Navbar = () => {
  return (
    <nav
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1rem 2rem",
        backgroundColor: "white",
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        position: "sticky",
        top: 0,
        zIndex: 1000,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <img
          src={logo}
          alt="Logo"
          style={{ height: "40px", width: "40px", objectFit: "contain" }}
        />
        <h2 style={{ color: BRAND_COLOR, margin: 0 ,  fontWeight: "bold",}}>{BRAND_NAME}</h2>
      </div>

      {/*
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <Link to="/" style={{ textDecoration: "none", color: "black" }}>
          Home
        </Link>
        <Link to="/login" style={{ textDecoration: "none", color: "#007BFF" }}>
          Login
        </Link>
        <Link
          to="/register"
          style={{
            padding: "0.5rem 1rem",
            backgroundColor: "#007BFF",
            borderRadius: "5px",
            color: "white",
            textDecoration: "none",
            fontWeight: "500",
          }}
        >
          Register
        </Link>
      </div>
      */}
    </nav>
  );
};

export default Navbar;
